<template>
	<div>
		<div class="filter-toolbar">
			<span class="title">{{ title }}</span>
			<ResetButton :filterNames="['age_certifications']" />
		</div>

		<div class="age-certification-filter jw-padding">
			<div class="filter-section" v-if="constantStore.ageCertifications.movies.length > 0">
				<span class="filter-section__header">{{ $t('WEBAPP_MOVIES') }}</span>
				<div class="filter-section__options">
					<ToggleButton
						v-for="certificate in constantStore.ageCertifications.movies"
						:key="certificate.id"
						:disabled="isShowFilterSelected"
						:active="isFilterCurrentlyActive('age_certifications', certificate.technicalName)"
						:icon="'jw-check-icon'"
						@click.prevent="ageCertificationClicked(certificate.technicalName)"
					>
						{{ certificate.technicalName }}
					</ToggleButton>
				</div>
			</div>

			<div class="filter-section" v-if="constantStore.ageCertifications.shows.length > 0">
				<span class="filter-section__header">{{ $t('WEBAPP_TVSHOWS') }}</span>
				<div class="filter-section__options">
					<ToggleButton
						v-for="certificate in constantStore.ageCertifications.shows"
						:key="certificate.id"
						:disabled="isMovieFilterSelected"
						:active="isFilterCurrentlyActive('age_certifications', certificate.technicalName)"
						:icon="'jw-check-icon'"
						@click.prevent="ageCertificationClicked(certificate.technicalName)"
					>
						{{ certificate.technicalName }}
					</ToggleButton>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { CollectionType } from '@/enums/collection-type';
import type { FilterCollection, FilterName } from '@/stores/useFilterStoreTypes';

import ResetButton from '@/components/buttons/ResetButton.vue';
import ToggleButton from '@/ui-components/ToggleButton.vue';

import { isFilterActive } from '@/helpers/filter-helper';
import { TitleObjectType } from '@/interfaces/titles';

import { computed } from 'vue';
import { useFilterStore } from '@/stores/pinia/useFilterStore';
import { useConstantStore } from '@/stores/pinia/useConstantStore';

const props = defineProps<{
	collectionType: CollectionType;
	currentFilters: FilterCollection;
}>();

const { t } = useI18n();
const router = useRouter();

const constantStore = useConstantStore();
const filterStore = useFilterStore();

const title = computed(() => {
	let title = t('WEBAPP_AGERATING');

	if (constantStore.ageCertifications.organizations.length > 0) {
		title += ` (${constantStore.ageCertifications.organizations.join(',')})`;
	}

	return title;
});

const isMovieFilterSelected = computed(() => props.currentFilters.content_types.includes(TitleObjectType.MOVIE));
const isShowFilterSelected = computed(() => props.currentFilters.content_types.includes(TitleObjectType.SHOW));

function isFilterCurrentlyActive(filterName: FilterName, value: any) {
	return isFilterActive(filterName, value, props.currentFilters);
}

async function ageCertificationClicked(certificateName: string) {
	const selectedState: 1 | 0 = isFilterCurrentlyActive('age_certifications', certificateName) ? 0 : 1;
	const newRoute = await filterStore.toggle({
		filterName: 'age_certifications',
		value: certificateName,
		selectedState,
	});

	if (newRoute) router.push(newRoute);
}
</script>

<style scoped lang="scss">
.age-certification-filter {
	.filter-section {
		padding: 0 5px;

		&__options {
			display: flex;
			flex-flow: wrap;
			margin-top: 5px;
		}
	}
}
</style>
